import { Col, Row } from 'antd';
import LinkButton from 'component/button/LinkButton';
import { useAppContext, useI18n, useViewContext } from 'core';
import styled from 'styled-components';

const RootComponent = styled.div`
    padding: 20px 20px 80px 40px;
`;
const Back = styled(Col)`
    .ant-btn {
        padding: 0;
    }
`;

const Title = styled(Col)`
    font-size: 30px;
    font-weight: 300;
    font-family: 'ROBOTO';
    text-transform: capitalize;
    color: #777;
    padding: 5px 5px 10px 0;
    white-space: nowrap;
`;

const Section = ({ title = null, label = null, marge = '0px', headerAction = null, backAction = null, children }) => {
    const { i18n } = useI18n();
    const { uc } = useViewContext();
    const { appName } = useAppContext();
    document.title = appName + ' ' + (title ? i18n(title) : '');

    return (
        <RootComponent>
            {backAction && (
                <Row>
                    <Back span={24}>
                        <LinkButton action={backAction} />
                    </Back>
                </Row>
            )}
            <Row>
                <Title flex="none"> {label || (title && i18n(title)) || i18n(uc + '.title')}</Title>
                <Col flex="auto">
                    <div>{headerAction}</div>
                </Col>
            </Row>
            <Row style={{ padding: marge }}>
                <Col span={24}>
                    <div>{children}</div>
                </Col>
            </Row>
        </RootComponent>
    );
};

export default Section;
